const getters = {
  getUser: (state) => () => state.user.user,
  userLoadingState: (state) => () => state.loadingState,
}

export default getters;
